export default __webpack_public_path__ + "static/logo-66054f002ab7ad4351891a69a5b07cc9.png";